/**
 * Landing page — Apple-style redesign.
 *
 * Composes the page from focused sub-components under
 * /components/landing/. The page itself is intentionally small.
 */

import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { useAuth } from '../lib/auth-context';

import { HomeHero } from '../components/landing/HomeHero';
import { MakeoverStorySection } from '../components/landing/MakeoverStorySection';
import { MakeoverDeliverablesSection } from '../components/landing/MakeoverDeliverablesSection';
import { MakeoverBeforeAfterSection } from '../components/landing/MakeoverBeforeAfterSection';
import { MakeoverApproachSection } from '../components/landing/MakeoverApproachSection';
import { PricingSection } from '../components/landing/PricingSection';
import { FAQSection } from '../components/landing/FAQSection';
import { StickyScoreCta } from '../components/landing/StickyScoreCta';
import SeoHead from '../components/seo/SeoHead';

export default function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth() || {};
  const onPrimaryCta = useMemo(
    () => () => {
      if (user) navigate('/dashboard');
      else navigate('/signup');
    },
    [navigate, user]
  );

  return (
    <AppShell>
      <SeoHead
        title={"Blayzrr — Free LinkedIn profile score in 10 seconds"}
        description={"Get an instant, AI-audited score for your LinkedIn profile and see the #1 thing to fix first. Free, no card required — then unlock the full audit + rewrite whenever you're ready."}
        path={"/"}
      />
      <HomeHero />
      {/* New makeover story stack (Oct 2026). Replaces the previous
          OutcomeTabs / Personas / Marquee / FeatureShowcase /
          Promise / MidScrollCTA stack with a tighter, citation-rich
          narrative: why clarity matters → what's included → before/
          after → how AI + expert thinking combine. */}
      <MakeoverStorySection />
      <MakeoverDeliverablesSection />
      <MakeoverBeforeAfterSection />
      <MakeoverApproachSection />
      <PricingSection />
      <FAQSection />
      <StickyScoreCta />
    </AppShell>
  );
}
